import React from "react";
import "./Header.css";

import { useNavigate } from "react-router-dom";

import ktplLogo from "../../assets/1.png";
import starLogo from "../../assets/2.png";
import iworkkzWhiteLogo from "../../assets/iWORKKZ-White 3.png";
import { authStore } from "../../store/authStore";

export default function Header() {
  const navigate = useNavigate();

  const user = authStore.getAuthData().user;

const companyId = Number(user?.company_id);

const companyLogo = {
  1: ktplLogo,
  2: starLogo,
}[companyId];

  const hour = new Date().getHours();

  let greeting = "Good Evening";
  let icon = "🌙";

  if (hour >= 5 && hour < 12) {
    greeting = "Good Morning";
    icon = "☀️";
  } else if (hour >= 12 && hour < 17) {
    greeting = "Good Afternoon";
    icon = "☀️";
  } else if (hour >= 17 && hour < 20) {
    greeting = "Good Evening";
    icon = "🌤️";
  }

  return (
    <header className="desktop-header">
      <div className="desktop-header-left">
        <img
          src={companyLogo}
          alt="Company Logo"
          className="desktop-header-star-logo"
        />

        <div className="header-divider"></div>

        <img
          src={iworkkzWhiteLogo}
          alt="iWORKKZ"
          className="desktop-header-iworkkz-logo"
        />
      </div>

      <div className="desktop-header-center">
        <h1>iAttendance</h1>
      </div>

      <div className="desktop-header-right">
        <div className="desktop-header-greeting">
          <span className="greeting-icon">{icon}</span>
          <span className="greeting-text">{greeting}</span>
        </div>

        <div
          className="desktop-top-profile-avatar"
          onClick={() => navigate("/admin/desktop/profile-master")}
        >
          <img
            src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
            alt="profile"
          />
        </div>

        <span className="desktop-user-name">{user?.name || "Admin"}</span>
      </div>
    </header>
  );
}
